package com.trevorwiebe.timesheet.admin.carrier.presentation

import com.trevorwiebe.timesheet.core.domain.model.Carrier

sealed class CarriersEvent {
    data object OnAddCarrierClick : CarriersEvent()
    data class OnEditCarrierClick(val carrier: Carrier) : CarriersEvent()
    data object OnDismissDialog : CarriersEvent()
    data class OnSaveCarrier(
        val contactName: String,
        val companyName: String,
        val address: String,
        val phone: String,
        val email: String,
        val notes: String,
        val active: Boolean
    ) : CarriersEvent()
    data object OnDeleteCarrier : CarriersEvent()
    data object OnRestoreCarrier : CarriersEvent()
    data class OnFilterToggled(val filter: CarrierFilter) : CarriersEvent()
    data class OnReorderCarriers(val orderedIds: List<String>) : CarriersEvent()
    data object OnErrorShown : CarriersEvent()
}
